export default "__VITE_ASSET__k$7L7NYe__"